import { Modifier } from 'react-day-picker';
import { RouteComponentProps } from 'react-router';

export interface TopupLoadItem {
  personId: number;
  firstName: string;
  lastName: string;
  amount: number;
  amountWithFees: number;
  date: string;
  status: string;
  numberOfWorkingDays: number;
  dailyAmount: number;
}

export interface ReportDetails {
  id: string;
  amount: number;
  benefitType: string;
  date: string;
  firstName: string;
  lastName: string;
  totalSumWithFees: number;
  numberOfWorkingDays: number;
  totalSum: number;
  status: string;
  scheduledOn: string;
  createdAt: string;
  topUpLoadItems: TopupLoadItem[];
}

export interface TopupsSummary {
  topUpLoads: ReportDetails[];
}

export interface TopupReportsDetailsBoxProps {
  reportDetails: ReportDetails;
}

export interface TopupReportsItemsTableProps {
  visibleReportItems: TopupLoadItem[];
  scheduledOn?: string;
  benefitType: string;
}

interface RouterProps {
  reportId: string;
}

export interface TopupReportsDetailsProps
  extends RouteComponentProps<RouterProps> {}

export interface TableHeaderTooltipProps {
  tooltipText: string;
}

export interface TopupReportsTableProps {
  visibleReports: ReportDetails[];
  isLoading: boolean;
}

export enum CorrectionReasonType {
  Custom = 'Custom',
  ContractTermination = 'ContractTermination',
  TooMuchMoneyTransferred = 'TooMuchMoneyTransferred',
  WrongAccountPayment = 'WrongAccountPayment',
  VatCorrection = 'VatCorrection'
}

export const SYSTEM_OPERATOR_NAME = 'system';

export interface CorrectionDetails {
  id: number;
  transactionDateTime: string;
  reasonType: CorrectionReasonType;
  reason: string;
  executedBy: string;
  balanceAfterCorrection: number;
  amount: number;
  documentId: string;
  operatorName: string;
}
export interface CardOrderDetails {
  orderDate: string;
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  cardOrderStatus: string;
  cardType: string;
  transactionLabel?: string;
  tooltipLabel?: string;
  tableRowKey?: string;
}

export interface CardOrdersResponse {
  pageSize: number;
  currentPage: number;
  totalPages: number;
  items: CardOrderDetails[];
}

export interface LoadRequestsResponse {
  pageSize: number;
  currentPage: number;
  totalPages: number;
  items: LoadRequestDetails[];
}

export interface LoadRequestsTableProps {
  loadRequests: LoadRequestDetails[];
  isLoading: boolean;
}

export interface LoadRequestsTableBodyProps {
  loadRequests: LoadRequestDetails[];
}

export interface CardOrdersTableProps {
  ordersHistory: CardOrderDetails[];
  isLoading: boolean;
}

export interface CardOrdersTableBodyProps {
  ordersHistory: CardOrderDetails[];
}

export interface LoadRequestDetails {
  requestDate: string;
  loadDate: string;
  userFirstName: string;
  userLastName: string;
  transactionStatus?: string;
  tooltip?: string;
  orderStatusId: number;
  requestStatusId: number;
  requestedForInDays: number;
  loadValue: number;
  totalLoad: number;
  totalDeduction: number;
}

export interface BalanceCorrectionsTableProps {
  correctionReports: CorrectionDetails[];
  isLoading: boolean;
}

export interface BalanceCorrectionsResponse {
  transactions: CorrectionDetails[];
  totalPages: number;
  totalRows: number;
}

export type BalanceCorrectionDate = Date | string | null;

export interface TransactionsDateRangeProps {
  isOpen: boolean;
  closeAction: () => void;
  disabledCustomDates: Modifier | Modifier[];
  from: BalanceCorrectionDate;
  to: BalanceCorrectionDate;
  setFrom: (from: BalanceCorrectionDate) => void;
  setTo: (to: BalanceCorrectionDate) => void;
}

export interface DepositDetails {
  id: number;
  amount: number;
  paymentMethod: string;
  paymentMethodId: number;
  paymentStatus: string;
  paymentStatusId: number;
  orderStatusId: number;
  orderStatus: string;
  paymentDate: string;
  createdAt: string;
}

export interface DepositsResponse {
  currentPage: number;
  totalPages: number;
  rowsPerPage: number;
  totalCount: number;
  items: DepositDetails[];
}

export interface DepositsTableProps {
  deposits: DepositDetails[];
  isLoading: boolean;
}

export interface DepositsTableBodyProps {
  deposits: DepositDetails[];
}
